var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cool-light-box',{attrs:{"items":_vm.items,"index":_vm.index,"useZoomBar":"","loop":""},on:{"close":function($event){_vm.index = null}}})
}
var staticRenderFns = []

export { render, staticRenderFns }